'use strict';
const BaseView = require('components-framework/view/base.view');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');
const trackingUtils = require('od-modules/utils/tracking.utils');
const appSplashOverlay = require('components/user_area/open_ticket/js/app_splash_overlay');
const tripDetailsAfDpFactory = require('components/user_area/open_ticket/js/tripdetails_afdp_factory');

const ACCEPTED_LAYER_PAGE = 'flexAccept';
const CUSTOMER_SUPPORT_LAYER_PAGE = 'flexSearch';
const ACCEPTED_PAGE_CRL = 'flexAcceptCRL';
const ACCEPTANCE_PAGE_CRL = 'myarflCRL';

module.exports = withCachedSelectors(BaseView.extend({
    templateSettings: {
        evaluate: /\{\{#([\s\S]+?)\}\}/g,
        interpolate: /\{\{[^#{]([\s\S]+?)[^}]\}\}/g,
        escape: /\{\{\{([\s\S]+?)\}\}\}/g,
    },

    CSS_CLASSES: {
        OD_OVERFLOW: 'od-overflow',
    },

    TRACKING: {
        CASH_REFUND_ACTION: 'auto_cash_refund',
        ONLOAD_LABEL_PREFIX: 'onload',
        ONLOAD_PARAMS: ['booking', 'id', 'pag'],
        TRACKING_PARAMS: ['status', 'flex', 'id', 'pag'],
        OPEN_APP_SPLASH_CLICK_BUTTON: {
            EVENT: 'OPEN_APP_SPLASH_CLICK_BUTTON',
            ACTION: 'trip_details_flexible_ticket',
            PARTIAL: 'refund-status-click',
            PNR: '',
        },
        DOWNLOAD_APP_SPLASH_REFUND_BUTTON: {
            EVENT: 'DOWNLOAD_APP_SPLASH_REFUND_BUTTON',
            ACTION: 'trip_details_flexible_ticket',
            PARTIAL: 'appsplash-button',
            PNR: '',
        },
        DOWNLOAD_APP_SPLASH_REFUND_PHONE: {
            EVENT: 'DOWNLOAD_APP_SPLASH_REFUND_PHONE',
            ACTION: 'trip_details_flexible_ticket',
            PARTIAL: 'appsplash-phone',
            PNR: '',
        },
        CLOSE_APP_SPLASH_BG: {
            EVENT: 'CLOSE_APP_SPLASH_BG',
            ACTION: 'trip_details_flexible_ticket',
            PARTIAL: 'popup_greyspace',
            PNR: '',
        },
        CLOSE_APP_SPLASH_REFUND: {
            EVENT: 'CLOSE_APP_SPLASH_REFUND',
            ACTION: 'trip_details_flexible_ticket',
            PARTIAL: 'appsplash-close',
            PNR: '',
        },
        PAGE: {
            ACCEPTED_LAYER: ACCEPTED_LAYER_PAGE,
            CUSTOMER_SUPPORT_LAYER: CUSTOMER_SUPPORT_LAYER_PAGE,
            ACCEPTED_CRL: ACCEPTED_PAGE_CRL,
            ACCEPTANCE_CRL: ACCEPTANCE_PAGE_CRL,
        },
    },

    selectors: {},

    events: {
        'tap .close_overlay': 'closeOverlay',
        'tap .close_overlay_background': 'closeOverlayBackground',
        'tap .open_app_splash_link_button': 'openAppSplashLinkButton',
        'tap .open_app_splash_link_phone': 'openAppSplashLinkPhone',
    },

    initialize({parentWidget, cashRefundPNRs, bookingInfo, trackingInfo, options}) {
        this.model.set({parentWidget, cashRefundPNRs, bookingInfo, trackingInfo, renderPNRCards: options.renderPNRCards});
        this.model.set('bookingId', bookingInfo.bookingBasicInfo.id);
        this.model.set('buyerMail', bookingInfo.buyer.mail);
        this.appSplashOverlay = appSplashOverlay.factory(this, bookingInfo);
        this.render();
        this.trackWidgetLoad();
    },

    render() {
        const {keys, templates} = this;
        const imagePath = Odigeo.UserArea.imagePath;
        const {formatDate, replaceCmsKeyArgs} = Odigeo.Utils;
        const renderPNRCards = this.model.get('renderPNRCards');
        const pnrsRendered = Odigeo._.reduce(this.model.get('cashRefundPNRs'), (pnrsRendered, pnrInfo, pnr) => {
            const templateData = Object.assign({}, pnrInfo, {pnr, renderPNRCards, keys, templates, imagePath, formatDate, replaceCmsKeyArgs});
            const renderedTemplate = templates.refundPnrBox(templateData);
            pnrsRendered.push(renderedTemplate);
            return pnrsRendered;
        }, []);
        this.$el.html(pnrsRendered);
        this.updateDomSelectorsToCache();
    },

    trackWidgetLoad() {
        const trackingInfo = Object.assign({}, this.model.get('trackingInfo'));
        const label = trackingUtils.composeLabel(this.TRACKING.ONLOAD_LABEL_PREFIX, this.TRACKING.ONLOAD_PARAMS, trackingInfo);
        trackingUtils.trackEvent(this.TRACKING.CASH_REFUND_ACTION, label);
    },

    openAppSplashOverlay(pnr, notificationManagerScope) {
        const pnrInfo = this.model.get('cashRefundPNRs')[pnr];
        pnrInfo.pnr = pnr;
        if (Odigeo.Utils.isMobile()) {
            this.appSplashOverlay.open(appSplashOverlay.versions.refund, pnrInfo, 50, notificationManagerScope);
        } else {
            this.appSplashOverlay.open(appSplashOverlay.versions.refund, pnrInfo, 0, notificationManagerScope);
        }
    },

    closeOverlayBackground(e) {
        const $currentTarget = $(e.currentTarget);

        if ($currentTarget[0] === $(e.target)[0]) {
            if (Odigeo.Utils.isMobile()) {
                this.appSplashOverlay.close();
            }
            this.appSplashOverlay.trackCloseBackground(e);
            e.stopPropagation();
        }
    },

    closeOverlay(e) {
        const $currentTarget = $(e.currentTarget);

        if ($currentTarget[0] === $(e.target)[0]) {
            this.appSplashOverlay.close();
            this.appSplashOverlay.trackClose(e);
            e.stopPropagation();
        }
    },

    openAppSplashLinkButton(event) {
        const $currentTarget = $(event.currentTarget);
        const version = $currentTarget.attr('data-splash-version');
        const pnr = $currentTarget.attr('data-openticket-pnr');
        const isFromNotificationManager = $currentTarget.attr('data-notification-scope');
        let customTrackingParams = {};
        const notificationManagerRefund = isFromNotificationManager === 'true' && version === 'refund';
        const appSplashDeferredLink = notificationManagerRefund ? this.keys.notificationCashRefundDeferredLink : this.keys.appSplashDeferredLink;

        customTrackingParams.pag = this.TRACKING.PAGE.ACCEPTED_LAYER;

        if (version === 'refund') {
            this.TRACKING.DOWNLOAD_APP_SPLASH_REFUND_BUTTON.PNR = pnr;
            this.trackEventWithData(this.TRACKING.DOWNLOAD_APP_SPLASH_REFUND_BUTTON.EVENT);
        }

        this._openDeferredDeepLink(appSplashDeferredLink);
        this.appSplashOverlay.close();
    },

    openAppSplashLinkPhone(event) {
        const $currentTarget = $(event.currentTarget);
        const version = $currentTarget.attr('data-splash-version');
        const pnr = $currentTarget.attr('data-openticket-pnr');
        const isFromNotificationManager = $currentTarget.attr('data-notification-scope');
        let customTrackingParams = {};
        const notificationManagerRefund = isFromNotificationManager === 'true' && version === 'refund';
        const appSplashDeferredLink = notificationManagerRefund ? this.keys.notificationCashRefundDeferredLink : this.keys.appSplashDeferredLink;

        customTrackingParams.pag = this.TRACKING.PAGE.ACCEPTED_LAYER;

        if (version === 'refund') {
            this.TRACKING.DOWNLOAD_APP_SPLASH_REFUND_PHONE.PNR = pnr;
            this.trackEventWithData(this.TRACKING.DOWNLOAD_APP_SPLASH_REFUND_PHONE.EVENT);
        }

        this._openDeferredDeepLink(appSplashDeferredLink);
        this.appSplashOverlay.close();
    },

    _openDeferredDeepLink(link) {
        const bookingId = this.model.get('bookingId');
        const email = this.model.get('buyerMail');
        const brand = Odigeo.SessionScope.brand;
        let afDpParam = tripDetailsAfDpFactory.tripDetailsAfDpFactory({brand, bookingId, email});
        const deferredLink = Odigeo.Utils.replaceCmsKeyArgs(link, afDpParam);

        window.open(deferredLink);
    },

    trackEventWithData(event, customTrackingInfo = {}, paramNames = this.TRACKING.TRACKING_PARAMS) {
        customTrackingInfo.flex = 'NA';
        let paramNamesList = paramNames.slice();
        this.trackEventWithParams(event, paramNamesList, customTrackingInfo);
    },

    trackEventWithParams(event, paramNames, customTrackingInfo = {}) {
        const trackingInfo = Object.assign({}, this.model.get('trackingInfo'), customTrackingInfo);
        const prefix = this.getTrackingLabelPrefix(event);

        const label = paramNames.reduce((acc, paramName) => {
            return `${acc}_${paramName}:${trackingInfo[paramName]}`;
        }, prefix);
        trackingUtils.trackEvent(this.TRACKING[event].ACTION, label);
    },

    getTrackingLabelPrefix(event) {
        const params = this.model.get('trackingInfo');

        if (event === 'GET_APP') {
            return `booking:${params.totalSections}-${params.totalPnrsInBooking}_${this.TRACKING[event].PARTIAL}`;
        } else {
            return `booking:${params.totalSections}-${this.TRACKING[event].PNR}_${this.TRACKING[event].PARTIAL}`;
        }
    },
}));
